var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdDescarga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.9 177.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4087f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #7bb929;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: #dadada;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.2,
    y: 29.8,
    width: 95.2,
    height: 95.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2077",
    "data-name": "Grupo 2077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417",
    "data-name": "Trazado 3417",
    className: "cls-4",
    d: "M22.8,22.8c30.4-30.4,79.6-30.4,110,0s30.4,79.6,0,110-79.6,30.4-110,0-30.4-79.6,0-110h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    className: "cls-4",
    cx: 77.8,
    cy: 77.8,
    r: 72.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31657",
    "data-name": "Grupo 31657"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31656",
    "data-name": "Grupo 31656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20880",
    "data-name": "Trazado 20880",
    className: "cls-1",
    d: "M121.7,118.3H33.9c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h87.8c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20881",
    "data-name": "Trazado 20881",
    className: "cls-1",
    d: "M75.3,100.8c.3.3.7.6,1.1.8h.2c.1,0,.3.1.5.1h1.5c.2,0,.4,0,.5-.2h0c.4-.2.7-.4,1-.7l20.3-20.3c1.3-1.3,1.2-3.4,0-4.7-1.3-1.3-3.3-1.3-4.6,0l-14.6,14.6v-56.6c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3v56.6l-14.6-14.6c-1.3-1.3-3.4-1.2-4.7,0-1.3,1.3-1.3,3.3,0,4.6l20.2,20.2-.2.2Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31655",
    "data-name": "Grupo 31655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2405",
    "data-name": "Trazado 2405",
    className: "cls-3",
    d: "M143.9,79.5c-27.1,0-49,21.9-49,49s21.9,49,49,49,49-21.9,49-49-22-49-49-49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1906",
    "data-name": "Grupo 1906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2406",
    "data-name": "Trazado 2406",
    className: "cls-5",
    d: "M167.2,117.7l-29.4,29.4c-1,1-2.4,1.6-3.9,1.6h-.6c-1.7-.2-3.2-1.1-4.1-2.6l-9.3-15c-1.6-2.6-.8-6,1.8-7.6,2.6-1.6,5.9-.8,7.6,1.8l5.6,9.1,24.5-24.5c2.1-2.2,5.6-2.2,7.8-.1,2.2,2.1,2.2,5.6.1,7.8h-.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdDescarga);
export default __webpack_public_path__ + "static/media/ID_descarga.6899fcbd0661cb0e423b8b3bc20a0f03.svg";
export { ForwardRef as ReactComponent };